import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "match-product-action-widget" }

import { OioButton, OioForm, OioFormItem, OioModal, OioInput, type FormItemRule } from '@kunlun/vue-ui-antd';
import { computed, reactive, ref } from 'vue';
import { OioTable, OioColumn, TableSize, type RuntimeModel, ClickResult } from '@kunlun/dependencies';
import { type IQueryTaskDetailItem, type productItem } from './service';

interface IProps {
  setFormData: (val: any) => Promise<ClickResult>;
  validationAndFillFunction: (val: string) => Promise<IQueryTaskDetailItem>;
  label: string;
  disabled: boolean;
  invisible: boolean;
  itemDetailList: productItem[];
}
type FormState = {
  code: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'RetailScheduledTask',
  props: {
    setFormData: null,
    validationAndFillFunction: null,
    label: null,
    disabled: { type: Boolean },
    invisible: { type: Boolean },
    itemDetailList: null
  },
  setup(__props: any) {

const props = __props as { setFormData: (val: any) => Promise<ClickResult>, validationAndFillFunction: (val: string) => Promise<IQueryTaskDetailItem>, label: string, disabled: boolean, invisible: boolean, itemDetailList: productItem[] }


const formState = reactive<FormState>({
  code: '' //都使用code
});
const codeName = computed(() => '69码');
const rules: Record<string, FormItemRule[]> = {
  code: [{ required: true, message: `请输入${codeName.value}` }]
};
const formRef = ref();

const matchProductPopupShow = ref(false);
const errorPopupShow = ref(false);
const confirmLoading = ref(false); //确定按钮loading
const errorList = ref<string[]>([]);
const tableData = computed(() => errorList.value.map((i) => ({ errorInfo: i })));
const hasError = computed(() => tableData.value.length > 0);
const openErrorPopup = () => {
  errorPopupShow.value = true;
};
//开始匹配
const startMatching = async () => {
  try {
    await formRef.value?.validate();
    confirmLoading.value = true;
    const res = await props.validationAndFillFunction(formState.code);
    errorList.value = [];
    if (res.errorInfos && res.errorInfos?.length > 0) {
      errorList.value = res.errorInfos;
      openErrorPopup();
    }
    if (res.itemDetailList && res.itemDetailList.length > 0) {
      const codes = props.itemDetailList.map((v) => v.code);

      const products = res.itemDetailList.filter((v) => !codes.includes(v.code));
      props.setFormData(props.itemDetailList.concat(products));
    }

    matchProductPopupShow.value = false;
  } catch (error) {
    console.error(error);
  } finally {
    confirmLoading.value = false;
    formState.code = '';
  }
};

const openMatchProductPopup = () => {
  matchProductPopupShow.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.invisible)
      ? (_openBlock(), _createBlock(_unref(OioButton), {
          key: 0,
          type: "primary",
          size: "small",
          disabled: __props.disabled,
          onClick: openMatchProductPopup
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.label), 1)
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true),
    (_unref(hasError) && __props.invisible)
      ? (_openBlock(), _createBlock(_unref(OioButton), {
          key: 1,
          type: "primary",
          size: "small",
          disabled: __props.disabled,
          onClick: openErrorPopup
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 异常信息 ")
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(OioModal), {
      visible: matchProductPopupShow.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((matchProductPopupShow).value = $event)),
      title: "匹配商品",
      height: "medium",
      maskClosable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: startMatching
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(OioForm), {
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          data: formState,
          "label-width": 80
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(OioFormItem), {
              name: "code",
              required: "",
              label: _unref(codeName)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(OioInput), {
                  value: formState.code,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.code) = $event)),
                  placeholder: '请输入' + _unref(codeName)
                }, null, 8, ["value", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(OioModal), {
      visible: errorPopupShow.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((errorPopupShow).value = $event)),
      title: "错误信息",
      height: "medium",
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(OioTable), {
          data: _unref(tableData),
          size: _unref(TableSize).small
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(OioColumn), {
              field: "errorInfo",
              label: "异常信息",
              width: "100%"
            })
          ]),
          _: 1
        }, 8, ["data", "size"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})